<template>
  <!-- Conditional rendering of prices based on discount -->
  <div :class="[className, 'relative']">
    <span
        :class="[
        className === 'single__price' && 'bg-opacity-0',
        colorVariant === 'green' && 'bg-lime-green',
        colorVariant === 'pink' && 'bg-hot-pink',
        colorVariant === 'amber' && 'bg-amber',
        colorVariant === 'sky' && 'bg-sky-blue',

        featureType.includes('is_active_discount') && 'text-hot-pink',
        featureType.includes('is_free_eu_shipping') && 'text-amber',
        featureType.includes('is_new') && 'text-sky-blue',
        featureType.includes('is_popular')  && 'text-lime-green',
        featureType.length === 0 && 'text-lime-green',
      ]"
    >
      <div class="inline-flex flex-col">
        <span>{{ showPricesWithTax ? prices.current_formatted_price_with_tax : prices.current_formatted_price }} </span>
        <span v-if="taxExplainText" class="pt-1 text-[16px] text-[#9e9e9e]">
          {{ in18['page_tax_explain'] }}
        </span>
      </div>
      <svg
          v-if="className !== 'single__price'"
          class="absolute right-[-10px] top-0 h-full"
          height="26"
          viewBox="0 0 12 26"
          width="15"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            :class="[
            colorVariant === 'green' && 'fill-lime-green',
            colorVariant === 'pink' && 'fill-hot-pink',
            colorVariant === 'amber' && 'fill-amber',
            colorVariant === 'sky' && 'fill-sky-blue',
          ]"
            d="M7.68306 0H0V26H2.49075C4.27291 26 5.8401 24.821 6.33405 23.1086L11.5264 5.10864C12.2641 2.55118 10.3448 0 7.68306 0Z"
        />
      </svg>
    </span>

    <template v-if="prices.is_active_discount">
      <del v-if="showPricesWithTax">{{ prices.previous_formatted_price_with_tax }}</del>
      <del v-else>{{ prices.previous_formatted_price }}</del>
    </template>

    <div v-if="prices.title" class="price_title">
      {{ prices.title }}
    </div>

    <span v-if="!taxExplainText" class="text-xs !text-[#818181] float-right">
        {{ in18['page_tax_explain'] }}
    </span>
  </div>
</template>

<script setup>
// Import necessary functions from Vue
import {computed, toRefs} from 'vue';
import {useStore} from 'vuex';

const store = useStore();

// Define props
const props = defineProps({
  prices:         Object,
  className:      String,
  colorVariant:   {
    type:    String,
    default: 'green', // Options: green, pink, amber, sky
  },
  taxExplainText: Boolean,
  in18:           {
    type: Object,
  },
  options:        {
    type:    Object,
    default: () => {
    },
  }
});

const {prices, className, colorVariant} = toRefs(props);

const featureType = computed(() => {
  if (!props.options) return []
  const types = [
    'is_new',
    'is_featured',
    'is_popular',
    'is_active_discount',
    'is_free_eu_shipping'
  ];
  return types.filter(type => props.options[type] === 1);
});

const showPricesWithTax = computed(() => store.state.showPricesWithTax);

</script>
